import { AppPhase, GameType } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { CardValue } from '../../models/communication/cards.enum';
import { YEventPayload } from '../../models/y-protocol.model';
import { BlackjackCardPosition } from '../game-types/blackjack/blackjack.model';

type Event = Omit<YEventPayload<AppEventType>, 'triggered'>;

export const configuration = {
    gameType: GameType.Blackjack,
    decisionTimeInSeconds: 4
};

// Mirrors dealer-assist: the hole card goes down as `card: 0`, the players decide,
// then the hole card is revealed and the dealer draws to a bust.
export const demoEvents: Array<Event | Event[]> = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.DealingCards
        }
    },

    {
        name: AppEventType.CardDealt,
        data: {
            card: CardValue.SpadeSix,
            cardPosition: BlackjackCardPosition.UpCard,
            nextCardPosition: BlackjackCardPosition.HoleCard,
            dealerHandValue: 6,
            dealerBusted: false,
            dealerBlackjack: false
        }
    },

    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: CardValue.Unknown,
                cardPosition: BlackjackCardPosition.HoleCard,
                nextCardPosition: BlackjackCardPosition.DrawCard1,
                dealerHandValue: 6,
                dealerBusted: false,
                dealerBlackjack: false
            }
        },

        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.Decision
            }
        }
    ],

    [
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.DealingCards
            }
        },

        {
            name: AppEventType.CardDealt,
            data: {
                card: CardValue.HeartFour,
                cardPosition: BlackjackCardPosition.HoleCard,
                nextCardPosition: BlackjackCardPosition.DrawCard1,
                dealerHandValue: 10,
                dealerBusted: false,
                dealerBlackjack: false
            }
        }
    ],

    {
        name: AppEventType.CardDealt,
        data: {
            card: CardValue.ClubThree,
            cardPosition: BlackjackCardPosition.DrawCard1,
            nextCardPosition: BlackjackCardPosition.DrawCard2,
            dealerHandValue: 13,
            dealerBusted: false,
            dealerBlackjack: false
        }
    },

    {
        name: AppEventType.CardDealt,
        data: {
            card: CardValue.DiamondKing,
            cardPosition: BlackjackCardPosition.DrawCard2,
            dealerHandValue: 23,
            dealerBusted: true,
            dealerBlackjack: false
        }
    }
];
